module.exports = __webpack_public_path__ + "img/loading-spinner.37939760.svg";